import { useCallback } from 'react';
import { useToast } from '@frameio/vapor';
import { MaxAssetCountPerBulkAction } from '../constants';
import type { BulkActions } from '../types';
import TEXT from './generated/TEXT/useBulkActionLimitToast';

const TOAST_DURATION = 2000;

TEXT.DEFINE({
  title: 'Limit Reached',
  details: (limit: number): string =>
    `Please try again with ${limit} items or fewer.`,
});

export const useBulkActionLimitToast = () => {
  const { addToast } = useToast();
  const { details, title } = TEXT;

  return useCallback(
    (action: BulkActions) => {
      /**
       * @todo (WORK-2691): Finalize action limits
       */
      const limit = MaxAssetCountPerBulkAction[action];

      addToast(
        {
          title,
          details: details(limit),
          variant: 'warning',
        },
        { duration: TOAST_DURATION }
      );
    },
    [addToast, details, title]
  );
};
